import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        commerceButton:'#1E2533',
        error: '#B00020',
        primary: '#006BAF',
        mpBlue: '#03b6fc',
        mpPink: '#F53BAD',
        accent: "#006BAF",
      }
    }
  }
})
